import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Container,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { Dialog } from "@mui/material";
import {
  CreateLockerColorThunk,
  CreateLockerKeyHelperThunk,
  CreateSegmentProducerThunk,
} from "../Redux/SettingsModule/SettingsThunks";
import { useDispatch } from "react-redux";

const SegmentProducersDialogSmall = ({}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [place, setPlace] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSend = () => {
    dispatch(CreateSegmentProducerThunk(place));
    setOpen(false);
  };

  return (
    <Container sx={{ width: "500px" }}>
      <Button
        onClick={() => {
          handleOpen();
        }}
      >
        Dodaj nowego Producenta Segmentu
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle variant="h5">Nowy Producent Segmentu</DialogTitle>
        <DialogContent>
          <DialogContentText>Wprowadz dane</DialogContentText>

          <TextField
            margin="dense"
            id="ProducerName"
            label="Nazwa Producenta"
            fullWidth
            variant="standard"
            onChange={(val) => {
              setPlace(val.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Anuluj</Button>
          <Button onClick={() => handleSend()}>Wyślij</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default SegmentProducersDialogSmall;
